/* eslint react/no-multi-comp: 0, no-unused-vars: 0 */

import React from 'react';
import { Section, preloader } from 'spectacle-ppa';
import Regionalization from '../../../../src/services/regionalization';

import balloonSlide from '../../baseSlides/balloonSlide';
import headingSlide from '../../baseSlides/headingSlide';
import videoSlide from '../../baseSlides/videoSlide';

import imageGameshowTitle from './title_gameshow.png';
import imageGameshowPlayers from './title_gameshow_players.png';

import apprenticeCurious from '../../images/characters/apprenticeCurious.png';
import apprenticePointingUp3 from '../../images/characters/apprenticePointingUp3.png';
import apprenticeHandsHips2 from '../../images/characters/apprenticeHandsHips2.png';
import apprenticeFistUp from '../../images/characters/apprenticeFistUp.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_knowTheRisks.md';

const levels = {
  '1': { md: new MarkdownScript(markdownFileLevel1) }
};

export function preloadGameShow () {
  preloader([
    imageGameshowTitle,
    imageGameshowPlayers,
    apprenticeCurious,
    apprenticePointingUp3,
    apprenticeHandsHips2,
    apprenticeFistUp
  ]);
}

function sizzle (level, regionData) {
  const md = levels[level].md;
  return headingSlide({
    id: 'sizzle',
    bgColor: '#742CBF',
    afterImage: imageGameshowTitle,
    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
  });
}

function scoring (level, regionData) {
  const md = levels[level].md;
  return balloonSlide({
    id: 'scoring',
    characterSide: 'right',
    characterImage: apprenticeHandsHips2,
    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
    bgColor: '#742CBF'
  });
}

function questionSlide ({
    questionNumber,
    numQuestions,
    md,
    questionCharacterImage,
    answerCharacterImage,
    regionData}) {
  const questionSection = `Question ${questionNumber}`;
  const defaultRegion = md.getSectionMetadata(questionSection,
                                              'Default Region',
                                              regionData);
  const questionCharacter = !questionCharacterImage ? apprenticeCurious : questionCharacterImage;
  const answerCharacter = !answerCharacterImage ? apprenticePointingUp3 : answerCharacterImage;
  let answer;
  if (defaultRegion) {
    answer = md.getSubSectionAsHtml(
                questionSection, `Answer - ${defaultRegion}`, false, regionData);
  } else {
    answer = md.getSubSectionAsHtml(questionSection, 'Answer', false, regionData);
  }
  const answerNotes = md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData);

  return [

    // four players announcement
    headingSlide({
      id: `${questionNumber}-four-players`,
      afterImage: imageGameshowPlayers,
      bgColor: 'black',
      notes: `<h2>Question ${questionNumber} of ${numQuestions}: </h2>` +
        md.getSubSectionAsHtml(
          'Four Players Announcement',
          'Notes',
          false, regionData
        )
    }),

    // question text
    balloonSlide({
      balloonType: `question`,
      characterSide: `left`,
      characterImage: questionCharacter,
      questionNumber,
      numQuestions,
      id: `${questionNumber}-question`,
      html: md.getSubSectionAsHtml(questionSection, 'Question', false, regionData),
      notes: `<h2>Question ${questionNumber} of ${numQuestions}: </h2>` +
        `<br />` +
        `<p style="font color: white">Preview of next slide/answer</h4>` +
        answer
    }),

    // answer slide
    balloonSlide({
      balloonType: `answer`,
      characterSide: `right`,
      characterImage: answerCharacter,
      questionNumber,
      id: `${questionNumber}-answer`,
      html: answer,
      notes: `<h2>Answer ${questionNumber} of ${numQuestions}</h2>` +
         `<br />` +
         ( !answerNotes.match(/SKIP/) ?
           md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData)
           : ''
         )
    })
  ];
}

function endOfGameShow (level) {
  return balloonSlide({
    id: 'end',
    characterSide: 'left',
    characterImage: apprenticeFistUp,
    bgColor: '#742CBF',
    html: `<h3>Game Show Completed!</h3>`,
    notes: 'Game show completed.'
  });
}

function level1 (regionData) {
  const level = 1;
  const md = levels[level].md;

  return (
    <Section id="game-show">

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Scoring intro */}
      {scoring(level, regionData)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 4, md, regionData })}
      {questionSlide({ level, questionNumber: 2, numQuestions: 4, md, regionData })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 4, md, regionData })}
      {questionSlide({ level, questionNumber: 4, numQuestions: 4, md, regionData })}

      {/* End of Game Show */}
      {endOfGameShow(level)}

    </Section>
  );
}

function gameShowSection ({ level, regionData }) {
  switch (level) {
  case 1:
    return level1(regionData);
  default:
    return headingSlide({ heading: 'Unknown' });
  }
}

export default gameShowSection;



// WEBPACK FOOTER //
// ./programs/epsHybridAssembly/sections/30_gameShow/gameShowSection.jsx